<template>
  <div class='banner'>
    <img src="@/assets/images/index/bannerBg.jpg" class="bg">
    <div class='downloadBT'>
      <img src="@/assets/images/index/googleBT.png" @click='gotoDownload("google")' class="googleBT">
      <img src="@/assets/images/index/iphoneBT.png" @click='gotoDownload("ios")' class="iphoneBT">
    </div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data () {
    return {
    }
  },
  mounted(){
  },
  methods:{
    gotoDownload(type){
      if(type=='google'){
        window.location.href='https://play.google.com/store/apps/details?id=com.digivision.xlqy'
      }
      if(type=='ios'){
        window.location.href='https://apps.apple.com/us/app/%E4%BB%99%E6%97%85%E5%A5%87%E7%B7%A3/id1593839868'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@fullWidth:19.2rem;

@bannerHeight:872/100rem;

@googleBTWidth:326/100rem;
@iphoneBTWidth:262/100rem;
@downloadGaps:.5rem;

.banner{
  position: relative;
  width: @fullWidth;
  height: @bannerHeight;
  .bg{
    position: absolute;
    width: @fullWidth;
    left: 0;
    top: 0;
  }
  .downloadBT{
    position: absolute;
    width: @googleBTWidth + @iphoneBTWidth + @downloadGaps;
    left: (@fullWidth - (@googleBTWidth + @iphoneBTWidth + @downloadGaps))/2;
    top: 5.7rem;
    .googleBT{
      position: absolute;
      width: @googleBTWidth;
      right: 0;
      top: 0;
      cursor:pointer;
    }
    .iphoneBT{
      position: absolute;
      width: @iphoneBTWidth;
      left: 0;
      top: 0;
      cursor:pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/banner.vue